<template>
  <div class="item pointer" @click="toDetail(data)">
    <el-image class="item-img" :src="data.articleImage" fit="cover">
      <div slot="error" class="item-img-error">暂无图片</div>
    </el-image>

    <div class="flex-1 item-box">
      <div class="item-title">{{ data.articleTitle }}</div>
      <!-- <div class="item-brief">{{ data.articleBrief }}</div> -->
      <div class="item-time">
        <span></span>
        {{ data.publishTime | transformTime }}
      </div>
    </div>
  </div>
</template>
<script>
import { parseTime } from "@/utils/index";
export default {
  filters: {
    transformTime(val) {
      return parseTime(val);
    },
    timeDay(val) {
      return parseTime(val, "{d}");
    },
    timeYearMonth(val) {
      return parseTime(val, "{y}-{m}");
    },
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  methods: {
    toDetail(data) {
      this.$router.push({ name: "newsDetail", query: { id: data.articleId } });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.block {
  text-align: center;
  color: white;
  background: $theme-color;
  padding: 0 5px;
  margin-right: 15px;
  border-radius: 5px;
  &-time {
    font-size: 12px;
  }
  &-day {
    font-size: 16px;
    font-weight: bold;
  }
}
.item {
  // padding: 15px;
  background: white;
  border-radius: 12px 12px 0 0;
  &:last-child {
    margin-bottom: 0;
  }
  &-img {
    width: 384px;
    height: 168px;
    border-radius: 12px 12px 0 0;
    ::v-deep .item-img-error {
      width: 100%;
      height: 100%;
      // background: #f5f5f5;
      color: #eee;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  &-box {
    padding: 16px;
  }
  &-title {
    font-size: 16px;
    font-weight: bold;
    color: #2c2c2c;
    margin-bottom: 16px;
  }
  &-brief {
    font-size: 14px;
    color: #777777;
    margin-bottom: 16px;
  }
  &-time {
    font-size: 14px;
    color: #777777;
  }
}
</style>
